import React from "react";
import { Skeleton } from "@mui/material";

const AddPeopleGroupLiveChatSkeleton = () => {
  return (
    <div className="tw-gap-6 tw-flex-col tw-flex">
      {/* Search Bar Skeleton */}
      {/* <div>
        <div className="tw-relative">
          <Skeleton 
            variant="rectangular" 
            width="25%" 
            height={40}
            className="tw-rounded-lg"
          />
        </div>
      </div> */}

      {/* Tiers Skeleton */}
      <div className="tw-space-y-3">
        {[1, 2, 3].map((tier) => (
          <div
            key={tier}
            className="tw-rounded-lg tw-overflow-hidden tw-bg-[#FFFFFF] tw-border tw-border-[#E9EAEB] tw-shadow-sm"
          >
            {/* Tier Header */}
            <div className="tw-p-4 tw-flex tw-justify-between tw-items-center">
              <Skeleton variant="text" width={200} height={24} />
              <Skeleton variant="circular" width={24} height={24} />
            </div>

            {/* Companies Skeleton (showing for first tier) */}
            {tier === 1 && (
              <div className="tw-p-5 tw-bg-white tw-border-t">
                {[1, 2].map((company) => (
                  <div
                    key={company}
                    className="tw-rounded-lg tw-overflow-hidden tw-bg-[#FFFFFF] tw-border tw-border-[#E9EAEB] tw-shadow-sm tw-mb-3"
                  >
                    {/* Company Header */}
                    <div className="tw-p-4 tw-flex tw-justify-between tw-items-center">
                      <Skeleton variant="text" width={150} height={24} />
                      <Skeleton variant="circular" width={24} height={24} />
                    </div>

                    {/* Users Grid (showing for first company) */}
                    {company === 1 && (
                      <div className="tw-p-4 tw-bg-white tw-border-t">
                        <div className="tw-grid tw-grid-cols-4 tw-md:tw-grid-cols-2 tw-lg:tw-grid-cols-4 tw-gap-4">
                          {[1, 2, 3, 4].map((user) => (
                            <div
                              key={user}
                              className="tw-px-4 tw-py-3 tw-bg-white tw-rounded-lg tw-border tw-border-[#E9EAEB] tw-flex tw-items-start tw-justify-between tw-space-x-3"
                            >
                              <div className="tw-flex tw-items-center tw-gap-4">
                                <Skeleton
                                  variant="circular"
                                  width={45}
                                  height={45}
                                />
                                <div>
                                  <Skeleton
                                    variant="text"
                                    width={100}
                                    height={20}
                                  />
                                  <Skeleton
                                    variant="text"
                                    width={120}
                                    height={16}
                                  />
                                </div>
                              </div>
                              <Skeleton
                                variant="rectangular"
                                width={20}
                                height={20}
                                className="tw-rounded"
                              />
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AddPeopleGroupLiveChatSkeleton;
